import { render } from "./NewDashboardPage.vue?vue&type=template&id=287a64a6"
import script from "./NewDashboardPage.vue?vue&type=script&lang=js"
export * from "./NewDashboardPage.vue?vue&type=script&lang=js"

import "./NewDashboardPage.vue?vue&type=style&index=0&id=287a64a6&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__